import React from "react";

const TimeIcon = ({
  fill = "#999999",
  size = 16,
}: {
  fill?: string;
  size?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.47645 7.81038V5.17126C8.47645 5.04445 8.43068 4.93529 8.33914 4.84378C8.24758 4.75228 8.13837 4.70653 8.0115 4.70653C7.88216 4.70653 7.77187 4.75228 7.68064 4.84378C7.5894 4.93529 7.54379 5.04445 7.54379 5.17126V7.95588C7.54379 8.02894 7.55746 8.09971 7.5848 8.1682C7.61216 8.23668 7.65435 8.29924 7.71137 8.35588L9.97777 10.6315C10.0666 10.7234 10.1748 10.7704 10.3021 10.7725C10.4295 10.7747 10.5414 10.7275 10.638 10.6309C10.7324 10.5365 10.7797 10.4266 10.7797 10.3014C10.7797 10.1762 10.7327 10.0655 10.6387 9.96943L8.47645 7.81038ZM8.00492 14.1982C7.14768 14.1982 6.34175 14.0353 5.58715 13.7094C4.83255 13.3836 4.17615 12.9414 3.61795 12.3828C3.05975 11.8243 2.61799 11.1684 2.29267 10.4153C1.96735 9.6621 1.80469 8.85735 1.80469 8.00101C1.80469 7.14377 1.9676 6.33785 2.29344 5.58325C2.61926 4.82865 3.06145 4.17225 3.62002 3.61405C4.17858 3.05585 4.83444 2.61409 5.5876 2.28876C6.34077 1.96344 7.14552 1.80078 8.00185 1.80078C8.8591 1.80078 9.66502 1.9637 10.4196 2.28953C11.1742 2.61535 11.8306 3.05755 12.3888 3.61611C12.947 4.17467 13.3888 4.83053 13.7141 5.5837C14.0394 6.33686 14.2021 7.14161 14.2021 7.99795C14.2021 8.85519 14.0392 9.66111 13.7133 10.4157C13.3875 11.1703 12.9453 11.8267 12.3868 12.3849C11.8282 12.9431 11.1723 13.3849 10.4192 13.7102C9.666 14.0355 8.86125 14.1982 8.00492 14.1982Z"
        fill={fill}
      />
    </svg>
  );
};

export default TimeIcon;
